import { createContext, useContext, useState } from 'react';

const RolesContext = createContext();

export default function RolesProvider({ children }) {
  const [roleNames, setRoleNames] = useState([]);

  return (
    <RolesContext.Provider value={{ roleNames, setRoleNames }}>
      {children}
    </RolesContext.Provider>
  );
};

export function useRoles() {
  return useContext(RolesContext);
}